interface dateTimeInputValue {
    date: Date, // local Date -- convertiert tu UTC mit Date.prototype.methods .toJSON() && .toISOString() --> wird automatisch ISO/UTC beim JSONStringify !! ()
    timezone: string // Intl.DateTimeFormat().resolvedOptions().timeZone - wenn ohne TimeZoneSelector || TimeZoneSelector._value.timezone
}

enum EvBookingEditor_ListNames {
    EvCast = "cast",
    EvProgram = "program",
    EvService = "service",
    evTasks = "evTasks",
    evCategories = "evCategories",
    orchesterEmployements = "orchestraEmployments",
    existingFiles = "existingFiles",
}

(globalThis as any).EvBookingEditor_ListNames = EvBookingEditor_ListNames; // (mds A11) esbuild cannot inline cross-file const enums; seed runtime value for bare refs

interface EvBookingEditor_SectionsConfig {
    isBookerSectionVisible: boolean,
    isTicketSectionVisible: boolean,

    isCastListVisible: boolean,
    isProgramListVisible: boolean,
    isServiceListVisible: boolean,
    isEvTasksListVisible: boolean,
    isEvCategoriesListVisible: boolean,
    isOrchesterEmployementsListVisible: boolean,
    isFilesSectionVisible: boolean,
}

interface EvBookingEditor_FormData {

}
